import { render, staticRenderFns } from "./CotizrRow.vue?vue&type=template&id=f9168680&"
import script from "./CotizrRow.vue?vue&type=script&lang=js&"
export * from "./CotizrRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports